import { render, staticRenderFns } from "./Home_soluciones.vue?vue&type=template&id=ef517c7c&scoped=true&"
import script from "./Home_soluciones.vue?vue&type=script&lang=js&"
export * from "./Home_soluciones.vue?vue&type=script&lang=js&"
import style0 from "./Home_soluciones.vue?vue&type=style&index=0&id=ef517c7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef517c7c",
  null
  
)

export default component.exports